import React, { useState, useEffect } from 'react';
import { db } from '../../config/firebase';
import { doc, setDoc, getDoc } from 'firebase/firestore';
import { useAuth } from '../../context/AuthContext';
import { DevelopmentNote } from '../../types/devNotes';
import './DevelopmentNotes.css';

const DevelopmentNotes: React.FC = () => {
  const { currentUser } = useAuth();
  const [notes, setNotes] = useState<string>('');
  const [saving, setSaving] = useState<boolean>(false);
  const [lastSaved, setLastSaved] = useState<Date | null>(null);

  // Load notes on component mount
  useEffect(() => {
    const loadNotes = async () => {
      try {
        const noteDoc = await getDoc(doc(db, 'developmentNotes', 'main'));
        if (noteDoc.exists()) {
          const noteData = noteDoc.data() as DevelopmentNote;
          setNotes(noteData.content);
          setLastSaved(noteData.updatedAt);
        }
      } catch (error) {
        console.error('Error loading notes:', error);
      }
    };

    loadNotes();
  }, []);

  // Save notes with debounce
  useEffect(() => {
    const saveTimeout = setTimeout(async () => {
      if (notes && !saving) {
        setSaving(true);
        try {
          const noteData: DevelopmentNote = {
            id: 'main',
            content: notes,
            createdAt: lastSaved || new Date(),
            updatedAt: new Date(),
            createdBy: currentUser?.email || 'unknown',
            lastEditedBy: currentUser?.email || 'unknown'
          };

          await setDoc(doc(db, 'developmentNotes', 'main'), noteData);
          setLastSaved(new Date());
        } catch (error) {
          console.error('Error saving notes:', error);
        } finally {
          setSaving(false);
        }
      }
    }, 1000); // Save after 1 second of no typing

    return () => clearTimeout(saveTimeout);
  }, [notes, currentUser, saving, lastSaved]);

  return (
    <div className="development-notes">
      <div className="notes-header">
        <h2>Development Notes</h2>
        <div className="save-status">
          {saving ? (
            <span className="saving">Saving...</span>
          ) : lastSaved ? (
            <span className="saved">Last saved: {lastSaved.toLocaleString()}</span>
          ) : null}
        </div>
      </div>
      <textarea
        value={notes}
        onChange={(e) => setNotes(e.target.value)}
        placeholder="Enter development notes, feature requests, or any other important information..."
        className="notes-textarea"
      />
    </div>
  );
};

export default DevelopmentNotes; 